// extracted by mini-css-extract-plugin
export default {"pageContainer":"NotFoundPage_pageContainer__XXZLC","pageDescription":"NotFoundPage_pageDescription__OPplW"};